import React, { Component, Fragment } from 'react';
import Modal from 'js/components/global/Modal';
import { Input } from 'react-nice-inputs';
import ReCAPTCHA from 'react-google-recaptcha';


// To-do: add error handling.

class ForgotPasswordModalWrapper extends Component {

  render() {

    /* eslint-disable camelcase */
    const { context } = this.props;
    const { fieldValidations, showRecoveryUserRecaptcha, showRecoveryPasswordRecaptcha, recaptchaToken } = context.state;
    const { status = '' } = context.state.recoverySSGResponse;
    const { isPassword } = context.state;
    const {
      username_recovery,
      email_recovery,
    } = fieldValidations;

    return(
      <Modal
        className="vw-pay sgg-modal"
        isOpen={context.state.isModalOpen.forgotPassword}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={context.closeModal('forgotPassword')}
        contentLabel="Privacy Policy Modal"
      >
        <Fragment>
          <h3 className="popup-subtitle util-txt-center push-down"><i className="icon-new-ssg"/></h3>
          <p className="util-center forgot-pass-block bold">
            Enter the email address registered in your account. We will send you an email with instructions.
          </p>
          <div className="row">
            { isPassword &&

              <Input type="text"
                name="username_recovery"
                classList={ (!username_recovery) ? ['is-invalid', 'sm-10', 'input-row', 'push-down', 'vacation-ssg-username'] : ['sm-10', 'input-row', 'push-down', 'vacation-ssg-username']}
                onChange={ (value, name) =>context.setRecoveryValue(value, name) }
                attrs={{placeholder: 'Username', maxLength: 50}}/>
            }

            { (!username_recovery && isPassword)  && <p className="is-invalid sm-12">Input is required or invalid.</p>}

            <Input type="text"
              name="email_recovery"
              classList={ (!email_recovery) ? ['is-invalid', 'sm-10', 'input-row', 'push-down', 'vacation-ssg-username'] : ['sm-10', 'input-row', 'push-down', 'vacation-ssg-username']}
              onChange={ (value, name) =>context.setRecoveryValue(value, name) }
              attrs={{placeholder: 'Email Address', maxLength: 50}}/>

            { !email_recovery && <p className="is-invalid sm-12">Input is required or invalid.</p>}

            { status === 'error' &&
              <p className="is-invalid sm-12">An unexpected error has occurred. Please visit <a href="https://sandalsselect.com/">Sandals Select Rewards</a> to receive further instructions.</p>
            }

            { status === 'success' &&
              <p className="sm-12 is-succeed">Thank you! If the email address is linked to an SSG Account, you will receive an email with further instructions.</p>
            }

            { showRecoveryUserRecaptcha && !isPassword &&
              <div className="recovery-recaptcha-wrapper">
                <ReCAPTCHA
                  ref={context.recoveryUserRecaptchaRef}
                  className="g-recaptcha"
                  name="recaptchaToken"
                  sitekey="6LfZYJUUAAAAAC4Kdfy2d4_XwIsODmNnao_zVCc5"
                  onChange={(value) => context.setSSGRecoveryState(value)}
                />
              </div>
            }
            { showRecoveryPasswordRecaptcha && isPassword &&
              <div className="recovery-recaptcha-wrapper">
                <ReCAPTCHA
                  ref={context.recoveryPasswordRecaptchaRef}
                  className="g-recaptcha"
                  name="recaptchaToken"
                  sitekey="6LfZYJUUAAAAAC4Kdfy2d4_XwIsODmNnao_zVCc5"
                  onChange={(value) => context.setSSGRecoveryState(value)}
                />
              </div>
            }
            { status === 'fail' && !recaptchaToken &&
              <p className="is-invalid sm-12">Input is required or invalid.</p>
            }

            <button className="sm-4 md-3 btn-primary input-row bold util-center" onClick={ () => context.submitSSGRecovery(isPassword) }>SUBMIT</button>
          </div>
        </Fragment>
      </Modal>
    );
    /* eslint-enable camelcase */
  }
}

export default ForgotPasswordModalWrapper;



// WEBPACK FOOTER //
// ./js/components/step1/ForgotPasswordModalWrapper.js